import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { Theme } from '@radix-ui/themes';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import ScoreResearcher from './components/ScoreResearcher';
import ScoreView from './components/ScoreView';
import './App.css';

export default function App() {
  return (
    <Theme className="site-theme" appearance="dark" accentColor="yellow" grayColor="slate" radius="medium">
      <BrowserRouter>
        <a className="skip-link" href="#main-content">Skip to content</a>
        <Navbar />
        <main id="main-content" className="site-shell" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/score_lookup" element={<ScoreResearcher />} />
            <Route path="/view_scores/:higherScore/:lowerScore" element={<ScoreView />} />
          </Routes>
        </main>
        <footer className="site-footer site-shell">
          <span>CFB Scorigami <span className="footer-divider">/</span> The college football score archive</span>
          <a href="https://www.twitter.com/CFBScorigami_" target="_blank" rel="noreferrer">
            @CFBScorigami_ <ArrowTopRightIcon />
          </a>
        </footer>
      </BrowserRouter>
    </Theme>
  );
}
